export default __webpack_public_path__ + "static/media/risk_level_2.fae68adb.png";